import {
  Activity,
  BookOpen,
  Boxes,
  ClipboardCheck,
  Download,
  Eye,
  FileText,
  Flame,
  Gift,
  GitCompare,
  GraduationCap,
  HardHat,
  Layers,
  Library,
  ListChecks,
  PenTool,
  Presentation,
  Ruler,
  ShieldCheck,
  Sparkles,
  Star,
  Users,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, highlighted card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Professional Visual Training Volumes', icon: Library, featured: true },
  { label: 'Complete 6-IN-1 Training System', icon: Boxes, featured: true },
  { label: 'Ready-to-Teach Lessons', icon: Presentation, featured: true },
  { label: 'Welding Fundamentals', icon: BookOpen },
  { label: 'Shop Safety & PPE', icon: HardHat },
  { label: 'Machine Setup & Settings', icon: Zap },
  { label: 'MIG/MAG Welding', icon: Flame },
  { label: 'TIG Welding', icon: Sparkles },
  { label: 'Stick Welding', icon: Wrench },
  { label: 'Metal Preparation', icon: Layers },
  { label: 'Blueprints & Symbols', icon: FileText },
  { label: 'Inspection & QC', icon: Eye },
  { label: 'Measuring & Layout', icon: Ruler },
  { label: 'Course Programs', icon: Users },
  { label: '❌/✅ Comparisons', icon: GitCompare },
  { label: 'Competency Rubrics', icon: ClipboardCheck },
  { label: 'Drills & Quick Checks', icon: ListChecks },
  { label: 'Easy to Advanced Variants', icon: Star },
  { label: 'Instructor Resources', icon: GraduationCap },
  { label: '5 Exclusive Bonuses', icon: Gift, featured: true },
  { label: 'Teaching Cues', icon: PenTool },
  { label: 'Lesson Plans', icon: Activity },
  { label: 'Safety Checklists', icon: ShieldCheck },
  { label: 'Immediate Digital Access', icon: Download },
]
